export enum Action{
    zeroBtn = 0,
    umBtn = 1,
    doisBtn = 2,
    tresBtn = 3,
    excluirBtn = 4,
}
